import React from 'react';

import { TDividerBlock } from '@wp-block-builder/blocks/Divider';
import { generateRandomBlockId } from '@wp-block-builder/package';

import BlockTypeIcon from '../../../../../blocks/helpers/BlockTypeIcon';

import defineBlockButton from './helpers/defineBlockButton';

const getDefaultProps = (style: { padding: string }): TDividerBlock => ({
  id: generateRandomBlockId(),
  type: 'Divider',
  style: { ...style },
  props: {
    lineColor: null,
    lineHeight: 1,
  },
  sectionProps: {},
});

const DEFAULT_STYLE = {
  padding: '16px 0 16px 0',
};

export default defineBlockButton<TDividerBlock>({
  label: 'Divider',
  icon: <BlockTypeIcon type="Divider" />,
  defaultBlock: () => getDefaultProps(DEFAULT_STYLE),
  defaultContainerBlock: () => getDefaultProps(DEFAULT_STYLE),
  defaultColumnBlock: () => getDefaultProps({ padding: '8px 0px 8px 0px' }),
});
